import React, { useEffect, useState } from "react";
import { withRouter } from "react-router";
import "./providerVerification.css";
import LoadingIndicator from "../../common/LoadingIndicator";
import { socketActions, socketSubActions } from "../../helper/Websocket";
import tick from "../../images/providerEmailVerification/tick.svg";
import cross from "../../images/providerEmailVerification/wrong.svg";
import Main from "./main";
import { isMobile, isAndroidDevice } from "../../helper/CommonFuncs";
function ProviderEmailVerification(props) {
   const [loading, setLoading] = useState(true);
   const [expire, setExpire] = useState(false);
   const searchParams = new URLSearchParams(props.location.search);
   const jwt = searchParams.get("jwt") || "";
   const verifyEmail = () => {
      if (jwt) {
         let str2 = {
            action: socketActions.onboarding,
            subAction: socketSubActions.verificationEmailByLink,
            JWTContent: jwt,
         };
         window.socket.send(str2, (data) => {
            setLoading(false);
            if (data.settings?.status !== 1) {
               setExpire(true);
            }
         });
      }
   };

   const resendVerificationLink = () => {
      if (jwt) {
         let str2 = {
            action: socketActions.onboarding,
            subAction: socketSubActions.verifyEmailProvider,
            JWTContent: jwt,
         };
         window.socket.send(str2, (data) => {});
      }
   };

   useEffect(() => {
      verifyEmail();
   }, []);

   const openApp = () => {
      let strAndroid = "?handle=android";
      let uriIos = "com.playbackhealth.pro://";
      let uriAndroid = "open-app-from-email-prod://" + strAndroid;
      if (process.env.REACT_APP_URL === "https://dev-api.playbackapi.com") {
         uriAndroid = "open-app-from-email://" + strAndroid;
         uriIos = "com.playbackhealth.providers://";
      }
      if (isAndroidDevice()) {
         window.location = uriAndroid;
      } else {
         window.location = uriIos;
      }
   };
   const userAgent = navigator.userAgent.toLowerCase();
   const isMobile = /iphone|ipad|ipod|android|blackberry|windows phone/.test(userAgent);
   return (
      <div className="loader-container-provider-email-verification">
         {loading ? (
            <div>
               <LoadingIndicator />
            </div>
         ) : (
            <>
               {expire ? (
                  <Main
                     src={cross}
                     title={"Your link has expired"}
                     subtitle={"Your verification link has expired after 2 hours and can only be used once"}
                     button={"Send me a new link"}
                     onClick={() => {
                        resendVerificationLink();
                     }}
                     classNameSubtitle="subtitle-provider-verification-margin"
                  />
               ) : (
                  <Main
                     src={tick}
                     title={"Email verified"}
                     subtitle={"Your email address was successfully verified."}
                     button={isMobile ? "Continue" : ""}
                     onClick={openApp}
                  />
               )}
            </>
         )}
      </div>
   );
}

export default withRouter(ProviderEmailVerification);
